import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ReligionBranchEditComponent } from '../religion-branch-edit/religion-branch-edit.component';

@Component({
  selector: 'app-religion-branch',
  templateUrl: './religion-branch.component.html',
  styleUrls: ['./religion-branch.component.css']
})
export class ReligionBranchComponent implements OnInit {

  public data: ReligionBranch[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {
    this.loadElements();
  }

  private loadElements() {
    this.isLoading = true;
    this.apiSvc.get("api/ReligionBranch/", null).subscribe(
      (data: ReligionBranch[]) => {
        this.data = data;
        console.log(this.data);
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
   );
  }

  public add() {
    const dialogRef = this.dialog.open(ReligionBranchEditComponent, {
    });
  }

  public edit(obj: ReligionBranch) {
    console.log(obj);
    const dialogRef = this.dialog.open(ReligionBranchEditComponent, {
    });
  }

  public delete(obj) {
     alert("Delete");
  }

}

export class ReligionBranch {
  Id: string;
  ParentId: string;
  Name: string;
  ReligionBranchTypeId: number;
}
